












import VueOptions from '@utils/VueOptions'
import EventService from '@services/EventService'

settings =
  name: "WorkflowProgressBar"

  vue:
    props: ['bar', 'themeComponent', 'options']

    components: {
      'progress-bar': () => import('./ProgressBar'),
      'progress-circle': () => import('./ProgressCircle'),
    }

    data: ->
      time: null
      stepProgress: {}

    mounted: ->
      @startPollTimer()

    beforeDestroy: ->
      @stopPollTimer()

    computed:
      barTheme: -> @themeComponent || 'progress-bar'
      progressBars: -> @getAppSession('progress_bars', [])
      steps: -> @bar.step_order.map((name) => @bar.to_h[name]).filter((step) -> step)

      barIsCompleted: ->
        completed = true
        completed = false for step in @steps when @stepProgress[step.name] < step.total
        completed

    methods:
      startPollTimer: ->
        @refreshProgressBar()

      stopPollTimer: ->
        clearTimeout @time

      removeBarFromSession: ->
        @setAppSession 'progress_bars', @progressBars.filter((b) => @bar.key isnt b.key)

      onStepCompleted: (step) ->
        @showFlash { info: "#{step.title} done" }
        @onProgressBarCompleted() if @barIsCompleted

      onProgressBarCompleted: ->
        @stopPollTimer()
        @removeBarFromSession()
        EventService.$emit('progress-bar-completed', @bar)

      refreshProgressBar: ->
        @stopPollTimer()
        (@refreshStep(step)) for step in @steps

      refreshStep: (step) ->
        progress = await @fetchProgress @bar.key, step.name
        @stepProgress[step.name] = progress || 0
        @stepProgress = Object.assign({}, @stepProgress)
        stepIsCompleted = @stepProgress[step.name] >= step.total

        if stepIsCompleted
          @onStepCompleted(step)
        else
          @time = setTimeout((() => @refreshStep(step)), 1000)

export default VueOptions.vue settings
